import { render, staticRenderFns } from "./editarCotacao2.vue?vue&type=template&id=016e4a08&scoped=true"
import script from "./editarCotacao2.vue?vue&type=script&lang=js"
export * from "./editarCotacao2.vue?vue&type=script&lang=js"
import style0 from "./editarCotacao2.vue?vue&type=style&index=0&id=016e4a08&prod&lang=css"
import style1 from "./editarCotacao2.vue?vue&type=style&index=1&id=016e4a08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016e4a08",
  null
  
)

export default component.exports